export default __webpack_public_path__ + "static/media/1596.0e10c589.png";